import { LoadingIndicator } from "../../common/VFX-UI";
import { useQuery } from "@tanstack/react-query";
import powerBiApi from "../../../app/model/api/powerBiApi";
import { PowerBIEmbed } from "powerbi-client-react";
import "./dashboard.css";

const Dashboard = () => {
  const dashboardId = window.location.pathname.split("/")[2];

  const authenticateQuery = useQuery({
    queryKey: ["authenticatePowerBi", dashboardId],
    queryFn: () => powerBiApi.authenticate(dashboardId),
    enabled: !!dashboardId && dashboardId !== "",
  });

  const config = authenticateQuery?.data?.result;

  const embedConfig = {
    type: "report",
    id: config?.dashboardId ?? "",
    tokenType: config?.tokenType,
    accessToken: config?.accessToken ?? "",
    embedUrl: config?.embedUrl ?? "",
    settings: {
      panes: {
        bookmarks: {
          visible: false,
        },
        fields: {
          expanded: false,
        },
        filters: {
          expanded: false,
          visible: false,
        },
        pageNavigation: {
          visible: false,
        },
        selection: {
          visible: false,
        },
        syncSlicers: {
          visible: true,
        },
        visualizations: {
          expanded: true,
        },
      },
    },
  };

  return authenticateQuery.isLoading ? (
    <LoadingIndicator />
  ) : (
    <>
      {!embedConfig.accessToken && (
        <div>Please speak with an administrator to see the dashboard.</div>
      )}
      {embedConfig.accessToken && (
        <div style={{ height: "80vh" }}>
          <PowerBIEmbed embedConfig={embedConfig} cssClassName={"report"} />
        </div>
      )}
    </>
  );
};

export default Dashboard;
